<template>
  <div class="step1">
    <div v-if="rows.length > 0">
      <vue-good-table
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: false
          }"
      />
      <div class="button-con">
        <CButton color="green" text="Allocate Order" @click="onNext"/>
      </div>
    </div>
    <div v-else>
      <span>There are no remaining items eligible for Allocation in this order.</span>
    </div>
  </div>
</template>

<script>
// import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import CButton from "../common/CButton.vue";


export default {
  name: 'Steps1',
  components:{
    VueGoodTable,
    CButton,
  },
  props: {
    orderData: Array,
    onNext: Function
  },
  data(){
    return{
      columns: [
        {
          label: 'Product Name',
          field: 'name',
          type: 'string',
        },
        {
          label: 'Vendor',
          field: 'vendor',
          type: 'string',
        },
        {
          label: 'Qty',
          field: 'qty',
          type: 'number',
        },
        {
          label: 'Allocated',
          field: 'allocated',
          type: 'number',
        },
        {
          label: 'Remaining',
          field: 'remains',
          type: 'number',
        },
      ],
    }
  },
  computed: {
    rows(){
      return this.orderData.filter((item)=>{
        return (item.productEnabled && item.remains > 0);
      }).map((item)=>{
        return{
          id: item.id,
          name: item.title,
          vendor: item.vendor,
          allocated: item.allocated,
          qty: item.qty,
          remains: item.remains,
          productEnabled: item.productEnabled
        }
      })
    }

  },
  mounted() {

  },
  methods: {}
}
</script>

